<!-- Banner showing logout message -->
@if (showBannerFlag) {
  <div class="sticky-banner">
    <mat-icon class="!w-[12%] sm:!w-[10%] md:!w-[4%] lg:!w-[3%]">info</mat-icon>
    <p class="text-xs md:text-sm w-half self-center">
      You have been logged out due to inactivity. Please log in again to continue.
    </p>
  </div>
}

<div class="flex flex-col flex-col-reverse md:flex-row md:gap-8" >
  <div class="md:w-[30%] w-full">
    <p class="md:text-3xl text-xl md:mb-12 mb-8 text-center mt-4">
      Welcome to our Partner Portal
    </p>
    <app-load-spinner-wrapper [loading]="loading">
      <ng-container *ngTemplateOutlet="cognitoLoginForm" />
    </app-load-spinner-wrapper>
  </div>
  <div class="md:w-[70%] w-full">
    <img
      src="assets/images/partnerPortalLoginImage.png"
      alt="Partner Portal"
      class="w-full h-auto">
  </div>
</div>
<ng-template #originalLoginForm>
  <form [formGroup]="loginForm" class="flex flex-col mb-4">
    <mat-form-field appearance="fill">
      <mat-label>Email</mat-label>
      <input matInput formControlName="userName">
      @if (loginForm.get('userName')?.hasError('required')) {
        <mat-error>
          Email is required.
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password">
      @if (loginForm.get('password')?.hasError('required')) {
        <mat-error>
          Password is required.
        </mat-error>
      }
    </mat-form-field>
    <a
      [routerLink]="'/forgot-password'"
      class="text-blue-600 underline"
      >
      Forgot password?
    </a>
    <br>
      <button
        mat-raised-button
        class="mt-4 !bg-green w-full mb-8"
        (click)="login()">
        <p class="md:text-lg text-base">Login</p>
      </button>
    </form>
  </ng-template>

  <ng-template #cognitoLoginForm>
    <amplify-authenticator [hideSignUp]="true" [formFields]="cognitoFormFields" [services]="cognitoServices">
      <ng-template amplifySlot="forgot-password-header">
        <p>Request a password reset code</p>
      </ng-template>
      <!-- Reset Password Custom Footer -->
      <ng-template amplifySlot="confirm-reset-password-footer" let-signIn="toSignIn">
        <div class="flex flex-col items-start mb-2 border border-white">
          <button
            class="hover:underline"
            amplify-button
            (click)="signIn()"
            type="button"
            variation="link">
            Back to Sign In
          </button>
        </div>
      </ng-template>
      <!--  Auth component footer  -->
      <ng-template amplifySlot="footer">
        <div class="flex-row py-1">
          <p>
            Don't have an account? <button
            class="underline"
            amplify-button
            [routerLink]="['/portal-registration']"
            type="button"
            variation="link">
            Register here.
          </button>

        </p>
      </div>
    </ng-template>
    <!--  Authenticated message -->
    <ng-template amplifySlot="authenticated">
      <h2>Logging you in...</h2>
    </ng-template>
  </amplify-authenticator>
</ng-template>
